export {
  OfficeViewerZoomControls as ZoomButtons,
  type OfficeViewerZoomControlsProps as ZoomButtonsProps,
} from '@/components/office/OfficeViewer/OfficeViewerZoomControls'
